module.exports = __webpack_public_path__ + "img/new_31.aa8d27ec.jpg";